// modifer: styles/jss/nextjs-material-kit-pro/pages/productStyle
import { section } from 'styles/jss/original/base';

const styles = {
  section: {
    ...section,
    padding: '20px 0'
  },
  purchase: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
};

export default styles;
